import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Linkedin } from 'lucide-react';
import { affiliations } from '../data/mock';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    if (window.location.pathname !== '/') {
      window.location.href = `/#${sectionId}`;
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-2xl font-bold mb-4">Dr. VPB Koyyala</h3>
            <p className="text-gray-400 mb-4">
              Medical Oncologist dedicated to providing world-class cancer care with compassion and expertise.
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/pradeepbabunaidu/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-700 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="http://linkedin.com/in/pradeepbabu-koyyala" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-teal-700 transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-gray-400 hover:text-teal-400 transition-colors">
                  About
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('expertise')} className="text-gray-400 hover:text-teal-400 transition-colors">
                  Expertise
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('achievements')} className="text-gray-400 hover:text-teal-400 transition-colors">
                  Achievements
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('publications')} className="text-gray-400 hover:text-teal-400 transition-colors">
                  Publications
                </button>
              </li>
              <li>
                <Link to="/blog" className="text-gray-400 hover:text-teal-400 transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <a href="mailto:pradeepbabu.koyyala@gmail.com" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  pradeepbabu.koyyala@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">+91 8099001565</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-teal-400 flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  Shankara Cancer and Research Institute, Tezpur, Assam
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Professional Affiliations</h4>
            <ul className="space-y-1 text-sm text-gray-400">
              {affiliations.slice(0, 6).map((affiliation) => (
                <li key={affiliation} className="truncate" title={affiliation}>
                  • {affiliation}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Dr. Venkata Pradeep Babu Koyyala. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;